import type { AdPlacement } from '@ahora-patagonia/contracts';

/**
 * Altos reservados por ubicación y corte (handoff §8). El servidor ya sabe si hay aviso, así
 * que el alto viaja reservado en el HTML y **nada se mueve cuando el creativo carga** (CLS 0).
 * Un snippet de red publicitaria que traiga otro tamaño se recorta (`overflow: hidden`): no
 * se le permite empujar la página.
 */
export interface AlturaPorCorte {
  /** 390 (hasta 599). */
  base: number;
  /** 600–1199. */
  desde600: number;
  /** ≥1200. */
  desde1200: number;
}

export const ALTURAS: Record<AdPlacement, AlturaPorCorte> = {
  HEADER: { base: 100, desde600: 90, desde1200: 250 },
  // El robapáginas vive solo en la columna lateral (≥1200); abajo de eso su inventario
  // pasa al flujo como IN_FEED (regla 7 del handoff).
  SIDEBAR: { base: 600, desde600: 600, desde1200: 600 },
  IN_FEED: { base: 250, desde600: 90, desde1200: 90 },
  IN_ARTICLE: { base: 250, desde600: 90, desde1200: 90 },
  FOOTER: { base: 100, desde600: 90, desde1200: 90 },
};

/** Ancho máximo del creativo por corte (medidas IAB vendibles por teléfono). */
export const ANCHOS: Record<AdPlacement, AlturaPorCorte> = {
  HEADER: { base: 320, desde600: 728, desde1200: 970 },
  SIDEBAR: { base: 300, desde600: 300, desde1200: 300 },
  IN_FEED: { base: 300, desde600: 728, desde1200: 728 },
  IN_ARTICLE: { base: 300, desde600: 728, desde1200: 728 },
  FOOTER: { base: 320, desde600: 728, desde1200: 728 },
};
